export default __webpack_public_path__ + "static/media/hamburger.718bbb05.svg";